<div class="grid">
  <div class="col-12 pb-0">
    <div class="card title-card flex px-0 pb-0">
      <div class="flex flex-column">
        <div class="flex flex-column sm:flex-row px-3 mb-2">
          <i class="pi pi-share-alt title-card-icon"></i>
          <div>
            <p class="mb-0 text-3xl title">{{'menu.shared' | transloco}}</p>
            <p>{{'menu.descriptions.shared' | transloco}}</p>
          </div>
        </div>
        <div *ngIf="this.items">
          <p-tabMenu
            #tab
            [model]="items"
            [activeItem]="activeItem"
            (click)="activateMenu(tab)"
            class="hidden xl:inline"
          ></p-tabMenu>
          <p-tabMenu
            #tabIcon
            [model]="items"
            [activeItem]="activeItem"
            (click)="activateMenu(tabIcon)"
            class="xl:hidden"
          >
            <ng-template pTemplate="item" let-item let-i="index">
              <i [className]="item.icon"></i>
            </ng-template>
          </p-tabMenu>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12" *ngIf="this.items">
    <app-shared-with-me *ngIf="activeItem.id == 'sharedWithMe'"></app-shared-with-me>
    <app-shared-by-user *ngIf="activeItem.id == 'sharedByUser'"></app-shared-by-user>
  </div>
</div>
